var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draft',{attrs:{"route":_vm.route},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})
}
var staticRenderFns = []

export { render, staticRenderFns }